// extracted by mini-css-extract-plugin
export default {"container":"DatePicker__container--2L5"};